<template>
    <v-btn
        width="100%"
        height="48px"
        class="secondary-action-btn"
        @click="$emit('clicked')"
    >   
        <span :class="text && 'pl-3'" style="margin-right:-1.3rem">
            <slot></slot>  
        </span>
        {{ text }}
    </v-btn>   
</template>

<script>
    export default {
        name: 'OutlineBtn',
        props:{
            text: {
                type: String,
                default: "",
            },
        }
    }
</script>

<style scoped>
.secondary-action-btn {
  box-shadow: 0 0 0 !important;
  border-radius: 4px !important;
  color: #1565c0 !important;
  font-size: 13px !important;
  line-height: 22px !important;
  border: 1px solid #1565c0;
}
</style>